// HowItWorks.styled.js
import styled from 'styled-components';
import { DEVICES } from '../../../config/appConfig';

export const ImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  max-width: 1400px;
  overflow: hidden;
`;

export const ResponsiveImage = styled.img`
  width: 100%;
  height: auto;
  object-fit: contain;
  display: block;

  /* Desktop */
  content: url(${({ images }) => images.desktop});

  /* Tablet */
  @media ${DEVICES.tablet} {
    content: url(${({ images }) => images.tablet});
  }

  /* Mobile */
  @media ${DEVICES.mobile} {
    content: url(${({ images }) => images.tablet});
  }

  /* Small Mobile */
  @media ${DEVICES.sMobile} {
    content: url(${({ images }) => images.mobile});
  }
`;
